import { IconProjection, VisualsProjection } from '@lib/sanity/types/common';

export function getIconVisual(icon?: IconProjection): VisualsProjection | undefined {
  if (!icon) {
    return undefined;
  }

  if (icon.iconSvg?.result?.trim().length) {
    return {
      _type: 'visuals',
      type: 'icon',
      icon: icon.iconSvg,
    };
  }
  return {
    _type: 'visuals',
    type: 'default',
    default: { image: { image: icon.icon } },
  };
}
